import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedTab: '0', // Default value for selected tab
};

const wheelSettings = createSlice({
  name: 'wheelSettings',
  initialState,
  reducers: {
    setWheelSettingsTab: (state, action) => {
      state.selectedTab = action.payload; 
    },
  },
});

// Export actions and reducer
export const { setWheelSettingsTab } = wheelSettings.actions;
export default wheelSettings.reducer;
